import Vue from 'vue';
import vueDataVueComponent from './vueData.vue.component';
import '../../scripts/lib/vue-event-bus.esm';

class BewertenVueData extends HTMLElement {
  /* eslint-disable class-methods-use-this */
  connectedCallback() {
    const $el = document.querySelector('#productData');
    const productJSON = JSON.parse($el.dataset.bewertenJsonContent);
    const syan = productJSON.syan;
    const article = productJSON.artikel;
    const initialKey = productJSON.artikelKey;
    const productDetailsJSON = JSON.parse($el.dataset.bewertenJsonPdContent);
    const trackingStaticData = JSON.parse($el.dataset.entsJsonEventTracking);

    Vue.config.ignoredElements = [
      /^shop-/,
      /^bewerten-/,
      /^ents-/,
      /^suchen-/,
      /^kaufen-click-and-reserve/,
      /^entd-/,
      /^brtn-/,
      /^camp-/,
    ];

    const component = vueDataVueComponent({
      syan,
      article,
      initialKey,
      productJSON,
      productDetailsJSON,
      trackingStaticData,
    });
    const vueData = new Vue(component); // eslint-disable-line @typescript-eslint/no-unused-vars
  }
}

window.customElements.define('bewerten-vue-data', BewertenVueData);
